<template>
  <el-dialog
    :visible.sync="isShowImageDialog"
    @closed="clearImg"
  >
    <!-- <el-carousel indicator-position="outside" height="600px">
      <el-carousel-item v-for="src in imgs">
       
      </el-carousel-item>
    </el-carousel> -->
      <img :src="imgs" style="max-width: 100%;max-height: 100%;display: block; margin: 0 auto;"/>
  </el-dialog>
</template>
 
<script>
export default {
  name: 'ImgPreview',
  data() {
    return {
      imgs: '',
      isShowImageDialog: false
    }
  },
  methods: {
    clearImg() {
      this.imgs = null
    }
  }
}
</script>
 
<style scoped>
 
</style>


// WEBPACK FOOTER //
// ImgPreview.vue?6f0e02db